export default __webpack_public_path__ + "static/media/10-ART-(3-4).30c24a70.jpg";